export const NavigationMenuWidth = 250;
